import React, { memo, useContext } from 'react';
import styles from './index.module.scss';
import SwitchDate, { IndexTimeActive } from './components/SwitchDate';
import CardBox from '../../../CardBox';
import ElectricityCostLeft from './components/ElectricityCostLeft';
import ElectricityCostRight from './components/ElectricityCostRight';
import PeakValleyLeft from './components/PeakValleyLeft';
import PeakValleyRight from './components/PeakValleyRight';
import PeakValleyBar from './components/PeakValleyBar';
import AlarmCountBox from './components/AlarmCountBox';
import { Dropdown } from '@maxtropy/components';
import dayjs from 'dayjs';
import { ShareDataUnityPowerMapContext } from '../..';
import { ShareDataWrapperContext } from '../../../..';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { V2ElectricMapConfigOverviewDetailPostResponse } from '@maxtropy/device-customer-apis-v2';
import classNames from 'classnames';

const LeftBox = ({ configDetail }: { configDetail: V2ElectricMapConfigOverviewDetailPostResponse | undefined }) => {
  const { isStandardSize, loadMap } = useContext(ShareDataWrapperContext);
  const {
    timeResolution: activeKey,
    dateValue: value,
    setActiveKey,
    setValue,
    rightExpanded,
    setRightExpanded,
  } = useContext(ShareDataUnityPowerMapContext);

  const showToggle = !isStandardSize && loadMap;
  const showRightPart = isStandardSize || !loadMap || rightExpanded;
  const isLargeNoMapLayout = !isStandardSize && !loadMap;

  return (
    <div className={classNames(styles.left_wrapper, isLargeNoMapLayout ? styles.left_wrapper_no_map : '')}>
      {/* 展开收起按钮 */}
      {showToggle && (
        <div className={styles.toggle_button} onClick={() => setRightExpanded?.(!rightExpanded)}>
          <div className={styles.toggle_text}>
            {rightExpanded ? (
              <>
                <span>收</span>
                <span>起</span>
              </>
            ) : (
              <>
                <span>展</span>
                <span>开</span>
              </>
            )}
          </div>
          <div className={styles.toggle_icon}>{rightExpanded ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}</div>
        </div>
      )}
      <div className={classNames(styles.container, isLargeNoMapLayout ? styles.container_no_map : '')}>
        {/* 左侧部分 - 固定宽度 */}
        <CardBox
          title="用电概况"
          className={classNames(styles.card_box, isLargeNoMapLayout ? styles.card_content_no_map : '')}
          style={{
            width: isLargeNoMapLayout || isStandardSize ? 0 : 440,
            flex: isLargeNoMapLayout || isStandardSize ? 1 : 'none',
            flexShrink: 0,
            paddingTop: 0,
            paddingRight: 0,
            height: isLargeNoMapLayout ? 'auto' : '100%',
            background: 'transparent',
            backdropFilter: 'none',
          }}
        >
          {/* 第一部分：用电成本右侧卡片 */}
          <div className={styles.section_1}>
            <ElectricityCostRight />
          </div>
          {/* 第二部分：峰谷占比饼图 */}
          <div className={styles.section_2}>
            <PeakValleyLeft />
          </div>
          {/* 第三部分左侧：近七日未恢复报警 */}
          <div className={styles.section_3}>
            <AlarmCountBox configDetail={configDetail} />
          </div>
        </CardBox>

        {/* 右侧部分 - 展开收起控制 */}
        {showRightPart && (
          <CardBox
            title=""
            className={isLargeNoMapLayout ? styles.card_content_no_map : ''}
            style={{
              width: isLargeNoMapLayout || isStandardSize ? 0 : 440,
              flex: isLargeNoMapLayout || isStandardSize ? 1 : 'none',
              flexShrink: 0,
              paddingTop: 0,
              height: isLargeNoMapLayout ? 'auto' : '100%',
              background: 'transparent',
              backdropFilter: 'none',
            }}
          >
            {/* 第一部分：峰谷占比右侧卡片 */}
            <div className={styles.section_1}>
              <PeakValleyRight />
            </div>
            {/* 第二部分：柱状图 */}
            <div className={styles.section_2}>
              <PeakValleyBar />
            </div>
            {/* 第三部分右侧：用电成本条形图 */}
            <div className={styles.section_3}>
              <ElectricityCostLeft />
            </div>
          </CardBox>
        )}
      </div>
    </div>
  );
};

export default memo(LeftBox);
